import { Button, InputNumber, Label, Select, TrashIcon } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import styles from './transport-company-route-item.module.css'
import { TransportCompanyRouteItemProps } from './transport-company-route-item.type'

export const TransportCompanyRouteItem = ({
  errors,
  isImporter,
  vehiclePrice,
  vehicles,
  disabledDelete,
  onHandleDelete,
  onHandleValues,
}: TransportCompanyRouteItemProps) => {
  const { t } = useTranslation('screenLogistic')

  return (
    <div>
      <div className={styles['route-item']}>
        <div>
          <Label>{t('vehiclePricesFormUnitLabel')}</Label>
          <Select
            onChange={(value) =>
              onHandleValues(vehiclePrice.index, 'vehicleUuid', value)
            }
            value={vehiclePrice?.vehicleUuid}
            placeholder={t('vehiclePricesFormUnitLabel')}
            options={vehicles.map((vehicle) => ({
              label: vehicle.name,
              value: vehicle.uuid,
            }))}
            error={
              errors[`routes[${vehiclePrice.index}]`] &&
              !vehiclePrice?.vehicleUuid
                ? t('requiredMessage')
                : undefined
            }
          />
        </div>
        <div>
          <Label>{t('vehiclePricesFormPriceLabel')}</Label>
          <div className={styles['number-and-add-box']}>
            <InputNumber
              placeholder={isImporter ? 'USD 0.00' : 'MXN 0.00'}
              decimalPrecision={2}
              prefix={isImporter ? 'USD ' : 'MXN '}
              stepSize={1}
              showIcons
              onChange={(value) =>
                onHandleValues(vehiclePrice.index, 'price', value)
              }
              value={vehiclePrice.price}
              error={
                errors[`routes[${vehiclePrice.index}]`] && !vehiclePrice?.price
                  ? t('requiredMessage')
                  : undefined
              }
            />
            {!isImporter && (
              <Button
                variant="secondary"
                model="square"
                className={styles['route-item-button']}
                disabled={disabledDelete}
                onClick={onHandleDelete}
              >
                <TrashIcon />
              </Button>
            )}
          </div>
        </div>
      </div>

      {isImporter && (
        <div className={styles['route-item-border']}>
          <div>
            <Label>{t('vehiclePricesFormInsurancePriceLabel')}</Label>
            <div className={styles['number-and-add-box']}>
              <InputNumber
                placeholder={isImporter ? 'USD 0.00' : 'MXN 0.00'}
                decimalPrecision={2}
                prefix={isImporter ? 'USD ' : 'MXN '}
                stepSize={1}
                showIcons
                onChange={(value) =>
                  onHandleValues(vehiclePrice.index, 'insurancePrice', value)
                }
                value={vehiclePrice.insurancePrice}
                error={
                  errors[`routes[${vehiclePrice.index}]`] &&
                  !vehiclePrice?.insurancePrice
                    ? t('requiredMessage')
                    : undefined
                }
              />
            </div>
          </div>
          <div>
            <Label>{t('vehiclePricesFormCrossDockingPriceLabel')}</Label>
            <div className={styles['number-and-add-box']}>
              <InputNumber
                placeholder={isImporter ? 'USD 0.00' : 'MXN 0.00'}
                decimalPrecision={2}
                prefix={isImporter ? 'USD ' : 'MXN '}
                stepSize={1}
                showIcons
                onChange={(value) =>
                  onHandleValues(vehiclePrice.index, 'crossDockingPrice', value)
                }
                value={vehiclePrice.crossDockingPrice}
                error={
                  errors[`routes[${vehiclePrice.index}]`] &&
                  !vehiclePrice?.crossDockingPrice
                    ? t('requiredMessage')
                    : undefined
                }
              />
              <Button
                variant="secondary"
                model="square"
                className={styles['route-item-button']}
                disabled={disabledDelete}
                onClick={onHandleDelete}
              >
                <TrashIcon />
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
